import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Request from '~/providers/Request';
import I18n from '~/i18n';

import Form from './Form';

function MedicalRecordEdit({ idClient, onCancel, onSuccess, record, setRecord }) {
  const [loading, setLoading] = useState(false);

  async function onSubmit() {
    const data = record.toParams({ user_id: idClient });

    Request.put(
      `/admin/medical_records/${idClient}`,
      data,
      {},
      { controller: 'medical_records' }
    )
      .then(() => {
        setLoading(false);
        toast.success(I18n.t('action.save_success'));
        onSuccess();
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      onCancel={onCancel}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

export default MedicalRecordEdit;
